import React, { useEffect, useRef, useState } from 'react'

import classNames from 'classnames'

type Props = {
  text: string
  className?: string
  maxLines?: number
  collapsedByDefault?: boolean
  showMoreLabel?: string
  showLessLabel?: string
}

export const CollapsibleText = ({
  text,
  className,
  maxLines = 3,
  collapsedByDefault = false,
  showMoreLabel = 'Show more',
  showLessLabel = 'Show less'
}: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsedByDefault)
  const [isTextTruncated, setIsTextTruncated] = useState(false)
  const textRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const checkTruncation = () => {
      if (!textRef.current) return
      const lineHeight = parseInt(
        window.getComputedStyle(textRef.current).lineHeight
      )
      setIsTextTruncated(textRef.current.scrollHeight > lineHeight * maxLines)
    }

    // Check initial truncation
    checkTruncation()

    // Set up resize observer
    const resizeObserver = new ResizeObserver(checkTruncation)
    if (textRef.current) {
      resizeObserver.observe(textRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [maxLines])

  return (
    <>
      <div
        className={classNames('collapsibleText', className, {
          collapsed: isCollapsed
        })}
        ref={textRef}
        style={{ WebkitLineClamp: isCollapsed ? maxLines : undefined }}
      >
        {text}
      </div>
      {isTextTruncated && (
        <button
          className='collapseTextButton'
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? showMoreLabel : showLessLabel}
        </button>
      )}
    </>
  )
}
